import { render, staticRenderFns } from "./SetOrderingParameter.vue?vue&type=template&id=3ffb0437&"
import script from "./SetOrderingParameter.vue?vue&type=script&lang=js&"
export * from "./SetOrderingParameter.vue?vue&type=script&lang=js&"
import style0 from "./SetOrderingParameter.vue?vue&type=style&index=0&id=3ffb0437&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports